import _classCallCheck from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var DragSourceImpl = /*#__PURE__*/function () {
  _createClass(DragSourceImpl, [{
    key: "beginDrag",
    value: function beginDrag() {
      var spec = this.spec;
      var monitor = this.monitor;
      var result = null;
      if (typeof spec.item === 'object') {
        result = spec.item;
      } else if (typeof spec.item === 'function') {
        result = spec.item(monitor);
      } else {
        result = {};
      }
      return result !== null && result !== void 0 ? result : null;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      var spec = this.spec;
      var monitor = this.monitor;
      if (typeof spec.canDrag === 'boolean') {
        return spec.canDrag;
      } else if (typeof spec.canDrag === 'function') {
        return spec.canDrag(monitor);
      } else {
        return true;
      }
    }
  }, {
    key: "isDragging",
    value: function isDragging(globalMonitor, target) {
      var spec = this.spec;
      var monitor = this.monitor;
      var isDragging = spec.isDragging;
      return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
  }, {
    key: "endDrag",
    value: function endDrag() {
      var spec = this.spec;
      var monitor = this.monitor;
      var connector = this.connector;
      var end = spec.end;
      if (end) {
        end(monitor.getItem(), monitor);
      }
      connector.reconnect();
    }
  }]);
  function DragSourceImpl(spec, monitor, connector) {
    _classCallCheck(this, DragSourceImpl);
    this.spec = spec;
    this.monitor = monitor;
    this.connector = connector;
  }
  return DragSourceImpl;
}();